'use client'

import ShowCaseCard from '@component/card/listings/showCase'
import GoogleAdvert from '@component/google/advert'
import classNames from 'classnames'
import { map } from 'lodash-es'
import { Fragment } from 'react'

export default function ShowCaseContent({
  data,
  showMap,
  onMouseEnter,
  onMouseLeave
}) {
  return (
    <section className='flex flex-col gap-y-24'>
      {
        map(data, (item, idx) => (
          <Fragment key={item.id}>
            {
              [3, 6, 11].includes(idx) && (
                <>
                  <GoogleAdvert desktopVisible={!showMap} mobileVisible={false} showTitle={false} showSub={false} adsize={[[970, 250], [728, 90]]} adunit='leaderboard' id={`ad-leaderboard-${idx}`} key={`ad-leaderboard-showcase-${idx}`}></GoogleAdvert>
                  <GoogleAdvert desktopVisible={showMap} showTitle={false} showSub={false} adsize={[300, 250]} adunit='rectangle' id={`ad-rectangle-${idx}`} key={`ad-rectangle-showcase-${idx}`}></GoogleAdvert>
                </>
              )
            }
            <ShowCaseCard
              key={item.id}
              data={item}
              showMap={showMap}
              className={classNames('rounded-sm shadow-card', showMap ? '' : 'pb-10 lg:p-16')}
              onMouseEnter={onMouseEnter}
              onMouseLeave={onMouseLeave}
            />
          </Fragment>
        ))
      }
    </section>
  )
}
